import {
  ensurePluginOrder,
  Hooks,
  TableInstance,
  useColumnOrder,
} from 'react-table';

const pluginName = 'useReorderableColumns';

export type UseReorderableColumnsProps = {
  resetColumnOrder: () => void;
};

const useInstance = <D extends Record<string, unknown>>(
  instance: TableInstance<D>
) => {
  const { columns, setColumnOrder, plugins } = instance;

  ensurePluginOrder(
    plugins,
    // mirroring useRowSelect's ordering
    ['useFilters', 'useGroupBy', 'useSortBy', 'useExpanded', 'usePagination'],
    'useReorderableColumns'
  );

  const initialColumnOrder = columns.map((c) => c.id);

  const additions: UseReorderableColumnsProps = {
    resetColumnOrder: () => {
      setColumnOrder(initialColumnOrder);
    },
  };

  Object.assign(instance, additions);
};

export const useReorderableColumns = <D extends Record<string, unknown>>(
  hooks: Hooks<D>
) => {
  useColumnOrder(hooks);
  hooks.useInstance.push(useInstance);
};

useReorderableColumns.pluginName = pluginName;
